import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";

import Panel from "../Panel/Panel";
import LoginForm from "./LoginForm";
import { usageLog } from "../../store/actions/globalActions";

const styles = (theme) => ({
  container: {
    minHeight: "100vh",
    height: "auto",
    padding: theme.spacing(4),
  },
  button: {
    borderRadius: "100px",
    margin: theme.spacing(2),
    border: "1px solid",
    borderColor: theme.palette.grey[300],
    fontSize: "0.75rem",
    "&:hover": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
});

const Login = (props) => {
  const { classes, loading, onAuth, authEmployee, isCompanyAuth } = props;
  const isEmployee =
    props.match && props.match.params.optionalPath === "funcionario";
  const redirectToSubscription =
    props.match && props.match.params.optionalPath === "assinatura";

  React.useEffect(() => {
    if (isCompanyAuth && redirectToSubscription) {
      props.history.push("/assinatura");
    }
  }, [isCompanyAuth, redirectToSubscription, props.history]);

  const [isGestor, setIsGestor] = useState(false)

  return (
    <Grid container>
      <Grid item xs container justify="center" className={classes.container}>
        <Grid container justify="flex-end">
          <Typography align="right" color="textSecondary">
            <Hidden xsDown>
              {isEmployee ? "Ainda não é registrado?" : "Não possui conta?"}
            </Hidden>
            {
              isEmployee ?
                <Button
                  component={Link}
                  to={"/registrar-empregado"}
                  color="inherit"
                  className={classes.button}
                >
                  {isEmployee ? "Registre-se" : "Criar conta"}
                </Button>
                :
                <Button
                  color="inherit"
                  className={classes.button}
                  onClick={() => {
                    window.location.href = "https://www.puntu.digital/cadastro"
                    usageLog('login/criarConta/paginaWix')
                  }}
                >
                  {isEmployee ? "Registre-se" : "Criar conta"}
                </Button>

            }
          </Typography>
        </Grid>

        <Grid item xs={12} sm={8} container direction="column">
          <Grid item>
            <Typography
              variant="h5"
              color="textSecondary"
              align="left"
              gutterBottom
            >
              Faça login no Puntu.
            </Typography>
            <Typography color="textSecondary" align="left" paragraph>
              {isGestor ? 'Preencha os campos abaixo.' : 'Escolha como quer fazer login.'}

            </Typography>
          </Grid>
          <Grid item style={{ height: "300px" }}>
            <LoginForm
              onAuth={onAuth}
              authEmployee={authEmployee}
              loading={loading}
              isEmployee={isEmployee}
              route={props.match.params.optionalPath}
              isGestor={isGestor}
              setIsGestor={setIsGestor}
            />
          </Grid>
        </Grid>
      </Grid>

      <Panel>
        <div>
          <Typography variant="h5" color="inherit">
            {isEmployee ? "Acompanhe seus Registros" : "Gerencie sua equipe"}
          </Typography>
          <Typography variant="h5" color="inherit" gutterBottom>
            {isEmployee
              ? "Aumente sua produtividade"
              : "Aumente sua produtividade"}
          </Typography>
          <Typography variant="body1" color="inherit" gutterBottom>
            {isEmployee
              ? "O Puntu é sua nova ferramenta de registro de ponto e acompanhamento das suas atividades"
              : "O Puntu é sua nova ferramenta para gerir de forma prática e rápida as horas trabalhadas do seus colaboradores."}
          </Typography>
        </div>
      </Panel>
    </Grid>
  );
};

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  onAuth: PropTypes.func.isRequired,
};

export default withStyles(styles)(Login);
